var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    strokeWidth: 3,
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-search--calendar-date-day-find-search-magnifier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30 26a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m27.75 31.75 5 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 124",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.013 9.27c.043 2.08 1.409 3.694 3.489 3.726a32.976 32.976 0 0 0 .996 0c2.08-.032 3.446-1.646 3.489-3.726a61.262 61.262 0 0 0 0-2.54c-.043-2.08-1.409-3.694-3.489-3.726a32.444 32.444 0 0 0-.996 0c-2.08.032-3.446 1.646-3.489 3.726a61.262 61.262 0 0 0 0 2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1103",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.013 9.27c.043 2.08 1.409 3.694 3.489 3.726a32.976 32.976 0 0 0 .996 0c2.08-.032 3.446-1.646 3.489-3.726a61.262 61.262 0 0 0 0-2.54c-.043-2.08-1.409-3.694-3.489-3.726a32.444 32.444 0 0 0-.996 0c-2.08.032-3.446 1.646-3.489 3.726a61.262 61.262 0 0 0 0 2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.003 8.562c-1.137.11-2.12.225-2.952.336-2.199.293-3.877 1.948-4.192 4.144C3.451 15.886 3 20.411 3 26.5c0 6.09.451 10.614.859 13.458.315 2.196 1.993 3.85 4.192 4.144 3.13.417 8.38.898 15.949.898 7.568 0 12.818-.481 15.949-.898 2.199-.294 3.877-1.948 4.192-4.144.408-2.844.859-7.369.859-13.458 0-6.09-.451-10.614-.859-13.458-.315-2.196-1.993-3.85-4.192-4.144a82.219 82.219 0 0 0-2.952-.336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29 8.074A164.037 164.037 0 0 0 24 8c-1.796 0-3.462.027-5 .074"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSearchIcon);
export default __webpack_public_path__ + "static/media/calendar-search-icon.719122bbc255cbe1410f8cdfdae95c18.svg";
export { ForwardRef as ReactComponent };